import {useCallback} from "react";
import useSafeState from "./useSafeState";

const useBoolean = (defaultValue) => {
    const [value, setValue] = useSafeState(!!defaultValue);
  
    const setTrue = useCallback(() => setValue(true), [setValue]);
    const setFalse = useCallback(() => setValue(false), [setValue]);
    const toggle = useCallback(() => setValue(x => !x), [setValue]);
  
    return { value, setValue, setTrue, setFalse, toggle };
  }

export default useBoolean;
